import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "col-md-12 mr-auto ml-auto" }
const _hoisted_2 = { class: "wizard-container" }
const _hoisted_3 = {
  class: "card card-wizard active exemplar-layout-card",
  "data-color": "primary"
}
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  key: 0,
  class: "mb-3 fw-semibold text-primary fs-5"
}
const _hoisted_6 = { class: "d-flex align-items-center gap-2 flex-wrap" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 1,
  class: "modal-backdrop-custom"
}
const _hoisted_9 = { class: "modal-custom" }
const _hoisted_10 = { class: "modal-body-custom" }
const _hoisted_11 = { class: "modal-footer-custom" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "row g-3 mt-1" }
const _hoisted_14 = { class: "col-xl-4 col-lg-5" }
const _hoisted_15 = { class: "card h-100 shadow-sm" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = ["aria-pressed", "onClick"]
const _hoisted_20 = {
  key: 0,
  class: "visually-hidden"
}
const _hoisted_21 = { class: "col-xl-8 col-lg-7" }
const _hoisted_22 = { class: "card h-100 shadow-sm" }
const _hoisted_23 = { class: "card-body" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-12" }
const _hoisted_26 = { class: "col-3 mb-3 d-inline-block me-2" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = { class: "col-3 mb-3 d-inline-block" }
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = { class: "col-6 mb-3" }
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = { class: "col-3 mb-3" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = { class: "col-6 mb-3" }
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = { class: "col-md-3 d-flex align-items-center mb-3" }
const _hoisted_37 = { class: "form-check" }
const _hoisted_38 = { class: "col-6 mb-3" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "col-md-3 d-flex align-items-center mb-3" }
const _hoisted_41 = { class: "form-check" }
const _hoisted_42 = { class: "col-3 mb-3" }
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = { class: "col-6 mb-3" }
const _hoisted_45 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_BarraBotoes = _resolveComponent("BarraBotoes")!
  const _component_ConsulteGrid = _resolveComponent("ConsulteGrid")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DropDownListBibLocalizacao = _resolveComponent("DropDownListBibLocalizacao")!
  const _component_DropDownListBibFormaAquisicao = _resolveComponent("DropDownListBibFormaAquisicao")!
  const _component_DropDownListBibMotivoBaixa = _resolveComponent("DropDownListBibMotivoBaixa")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, { onSubmit: _ctx.onSubmit }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Field, {
                name: "bibDocumentoId",
                type: "hidden",
                modelValue: _ctx.model.bibDocumentoId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.bibDocumentoId) = $event))
              }, null, 8, ["modelValue"]),
              (_ctx.descricaoDocumento)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.descricaoDocumento), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_BarraBotoes, {
                  loadingSave: _ctx.loadingSave,
                  idRegistroCarregado: _ctx.selectedId ? String(_ctx.selectedId) : '',
                  showSalvar: true,
                  gridViewLink: _ctx.getRouteContext().searchViewLink,
                  onLimpar: _ctx.limparFormulario,
                  onExcluir: _ctx.excluir
                }, null, 8, ["loadingSave", "idRegistroCarregado", "gridViewLink", "onLimpar", "onExcluir"]),
                (_ctx.showCopyButton)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary ms-2 px-4 py-2 rounded-3",
                      disabled: _ctx.loadingCopy,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.abrirPopupCopiar && _ctx.abrirPopupCopiar(...args)))
                    }, " Copiar ", 8, _hoisted_7))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.mostrarPopupCopiar)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "modal-header-custom" }, [
                        _createElementVNode("h5", { class: "mb-0" }, "Copiar")
                      ], -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[15] || (_cache[15] = _createElementVNode("label", {
                          for: "quantidadeCopias",
                          class: "form-label"
                        }, "Quantidade de cópias", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "quantidadeCopias",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.quantidadeCopias) = $event)),
                          class: "form-control",
                          type: "number",
                          min: "1",
                          step: "1"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.quantidadeCopias,
                            void 0,
                            { number: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-secondary",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelarPopupCopiar && _ctx.cancelarPopupCopiar(...args)))
                        }, " Cancelar "),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-primary",
                          disabled: _ctx.loadingCopy,
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.confirmarPopupCopiar && _ctx.confirmarPopupCopiar(...args)))
                        }, " Ok ", 8, _hoisted_12)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      (_openBlock(), _createBlock(_component_ConsulteGrid, {
                        key: _ctx.gridKey,
                        columns: _ctx.gridColumns,
                        "data-source": _ctx.dataSource,
                        actions: false,
                        hideHeader: true
                      }, {
                        body: _withCtx(() => [
                          (_ctx.dataSource.loading)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [...(_cache[17] || (_cache[17] = [
                                _createElementVNode("td", {
                                  colspan: "100%",
                                  style: {"height":"52.6px","padding-top":"10px"}
                                }, [
                                  _createElementVNode("div", { class: "spinner-border text-primary exemplar-grid-loader" })
                                ], -1)
                              ]))]))
                            : (_ctx.gridRows.length === 0)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [...(_cache[18] || (_cache[18] = [
                                  _createElementVNode("td", { colspan: "100%" }, [
                                    _createElementVNode("i", null, "Nenhum resultado")
                                  ], -1)
                                ]))]))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.gridRows, (row) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: row.bibExemplarId,
                                    class: _normalizeClass(["exemplar-grid-row", {
              'exemplar-grid-row-selected': _ctx.isRowSelected(row),
              'exemplar-grid-row-baixado': Number(row.baixado) === 1
             }])
                                  }, [
                                    _createElementVNode("td", null, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "exemplar-grid-botao",
                                        "aria-pressed": _ctx.isRowSelected(row) ? 'true' : 'false',
                                        onClick: ($event: any) => (_ctx.selecionarRegistro(row))
                                      }, [
                                        _createTextVNode(_toDisplayString(row.identificacao || "-") + " ", 1),
                                        (Number(row.baixado) === 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, "(baixado)"))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_19)
                                    ])
                                  ], 2))
                                }), 128))
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source"]))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _cache[19] || (_cache[19] = _createElementVNode("label", { for: "exemplar-tombamento" }, "Tombamento", -1)),
                              _createVNode(_component_Field, {
                                id: "exemplar-tombamento",
                                name: "identificacao",
                                class: _normalizeClass(["form-control", { 'readonly-field': !_ctx.editarTombamento }]),
                                type: "text",
                                modelValue: _ctx.model.identificacao,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.identificacao) = $event)),
                                readonly: !_ctx.editarTombamento,
                                maxlength: "30"
                              }, null, 8, ["class", "modelValue", "readonly"]),
                              _createVNode(_component_ErrorMessage, { name: "identificacao" })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _cache[20] || (_cache[20] = _createElementVNode("label", { for: "exemplar-codigo-barras" }, "Código de Barras", -1)),
                              _createVNode(_component_Field, {
                                id: "exemplar-codigo-barras",
                                name: "codigoBarra",
                                class: _normalizeClass(["form-control", { 'readonly-field': !_ctx.editarCodigoBarras }]),
                                type: "text",
                                modelValue: _ctx.model.codigoBarra,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.codigoBarra) = $event)),
                                readonly: !_ctx.editarCodigoBarras,
                                maxlength: "50"
                              }, null, 8, ["class", "modelValue", "readonly"]),
                              _createVNode(_component_ErrorMessage, { name: "codigoBarra" })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_DropDownListBibLocalizacao, {
                                modelValue: _ctx.model.bibLocalizacaoId,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.bibLocalizacaoId) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, { name: "bibLocalizacaoId" })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              _cache[21] || (_cache[21] = _createElementVNode("label", { for: "campo-dataAquisicao-02ad" }, "Data de Aquisição", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.dataAquisicao) = $event)),
                                class: "form-control",
                                type: "date",
                                name: "dataAquisicao",
                                id: "campo-dataAquisicao-02ad"
                              }, null, 512), [
                                [_vModelText, _ctx.model.dataAquisicao]
                              ]),
                              _createVNode(_component_ErrorMessage, { name: "dataAquisicao" })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(_component_DropDownListBibFormaAquisicao, {
                                modelValue: _ctx.model.bibFormaAquisicaoId,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.bibFormaAquisicaoId) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, { name: "bibFormaAquisicaoId" })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_Field, {
                                id: "podeEmprestar",
                                name: "podeEmprestar",
                                class: "form-check-input",
                                type: "checkbox",
                                modelValue: _ctx.model.podeEmprestar,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.podeEmprestar) = $event)),
                                value: 1,
                                "unchecked-value": 0
                              }, null, 8, ["modelValue"]),
                              _cache[22] || (_cache[22] = _createElementVNode("label", {
                                for: "podeEmprestar",
                                class: "form-check-label"
                              }, " Pode Emprestar ", -1)),
                              _createVNode(_component_ErrorMessage, { name: "podeEmprestar" })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _cache[23] || (_cache[23] = _createElementVNode("label", null, "Observação", -1)),
                              _createVNode(_component_Field, {
                                name: "observacao",
                                class: "form-control",
                                as: "textarea",
                                rows: "4",
                                modelValue: _ctx.model.observacao,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.observacao) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, { name: "observacao" })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _createVNode(_component_Field, {
                                id: "baixado",
                                name: "baixado",
                                class: "form-check-input",
                                type: "checkbox",
                                modelValue: _ctx.model.baixado,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.baixado) = $event)),
                                value: 1,
                                "unchecked-value": 0,
                                onChange: _ctx.onBaixadoChange
                              }, null, 8, ["modelValue", "onChange"]),
                              _cache[24] || (_cache[24] = _createElementVNode("label", {
                                for: "baixado",
                                class: "form-check-label"
                              }, " Baixado ", -1)),
                              _createVNode(_component_ErrorMessage, { name: "baixado" })
                            ])
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _cache[25] || (_cache[25] = _createElementVNode("label", null, "Data da Baixa", -1)),
                              _createVNode(_component_Field, {
                                name: "dataBaixa",
                                class: "form-control",
                                type: "date",
                                modelValue: _ctx.model.dataBaixa,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.dataBaixa) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, { name: "dataBaixa" })
                            ])
                          ], 512), [
                            [_vShow, Number(_ctx.model.baixado) === 1]
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_DropDownListBibMotivoBaixa, {
                                modelValue: _ctx.model.bibMotivoBaixaId,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.bibMotivoBaixaId) = $event))
                              }, null, 8, ["modelValue"]),
                              _createVNode(_component_ErrorMessage, { name: "bibMotivoBaixaId" })
                            ])
                          ], 512), [
                            [_vShow, Number(_ctx.model.baixado) === 1]
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ]))
}